import { awsApiUrl } from "./analysis";

export const getTTestResults = async (
  value,
  confidenceLevel,
  hypothesizedMean
) => {
  let CL = 0.95;

  if (confidenceLevel) {
    CL = confidenceLevel / 100;
  }

  const res = await fetch(`${awsApiUrl}/oneSampleTtest`, {
    method: "POST",
    body: JSON.stringify({
      value: value,
      meanHypothesis: Number(hypothesizedMean),
      confidenceLevel: Number(CL),
    }),
    headers: {
      "Content-type": "application/json",
    },
  });

  const result = res ? await res.json() : false;
  // console.log("getTTestResults: >>", result);
  return result;
};
